var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_1669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01172 12.75H23.2492C24.2242 12.75 24.2242 11.25 23.2492 11.25H7.01172C6.07422 11.25 6.07422 12.75 7.01172 12.75Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7758 11.5125L19.0508 6.78752C18.3758 6.11252 17.3258 7.16252 18.0008 7.83752L22.6883 12.525C23.4008 13.2 24.4508 12.15 23.7758 11.5125Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7254 11.5125L18.0379 16.2C17.3629 16.875 18.4129 17.925 19.0879 17.25L23.7754 12.5625C24.4504 11.85 23.4004 10.8375 22.7254 11.5125Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3995 14.625V17.4375C14.3995 17.9625 14.662 19.05 14.0245 19.2C13.387 19.35 12.637 19.2 12.037 19.2H2.21195C1.83695 19.2 1.61195 19.2 1.53695 18.7875C1.49945 18.2625 1.49945 17.7 1.53695 17.175V5.92501C1.53695 5.58751 1.42445 5.06251 1.79945 4.91251C2.17445 4.76251 2.92445 4.91251 3.29945 4.91251H13.7995C14.587 4.91251 14.437 5.55001 14.437 6.22501V9.4875C14.512 9.9 14.9245 10.1625 15.2995 10.0875C15.5995 10.0125 15.8245 9.78751 15.8995 9.4875V6.37501C15.8995 5.17501 15.9745 3.71251 14.3995 3.45001C13.7995 3.41251 13.237 3.37501 12.637 3.41251H2.13695C1.04945 3.41251 0.0744502 3.93751 -0.000549771 5.13751C-0.0380498 5.55001 -0.000549771 6.00001 -0.000549771 6.41251V16.35C-0.000549771 17.7375 -0.41305 20.2875 1.46195 20.6625C2.06195 20.7375 2.66195 20.7375 3.26195 20.7H13.7995C14.887 20.7 15.8245 20.175 15.8995 18.975C15.9745 17.8875 15.8995 16.8 15.8995 15.7125V14.625C15.8995 13.6875 14.3995 13.6875 14.3995 14.625Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_1669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9a4e32f01c3d587b23ea603f8e597add.svg";
export { ForwardRef as ReactComponent };